import { BaseService } from "./../../base";
export class HcmService extends BaseService {
  static async getTokenHCM() {
    return this.submit("get", `${this.getApiUrlEntity(this.profile)}patient/recuperarToken`, "access_token");
  }
  static async getPatientRecipe(rut) {
    const token = await this.getTokenHCM();
    return this.submit("get", `${this.getApiUrlEntity(this.profile)}patient/filter_by_document_recipe/${rut}/${token}/1`, null);
  }
  static async getPatientEpi(rut) {
    const token = await this.getTokenHCM();
    return this.submit("get", `${this.getApiUrlEntity(this.profile)}patient/filter_by_document_epi/${rut}/${token}/1`, null);
  }
  static async getPatientQxs(rut) {
    const token = await this.getTokenHCM();
    return this.submit("get", `${this.getApiUrlEntity(this.profile)}patient/filter_by_document_qx/${rut}/${token}/1`, null);
  }
}
